(ns client-portal.client.voice-insights.charts.data
  (:require [client-portal.client.concepts.data :as concepts.d]
            [client-portal.client.voice-insights.data :as vi.d]
            [clojure.string :as s]
            [cljs-time.coerce :as t.c]
            [cljs-time.format :as t.f]
            [shared.core.constants :as constants]
            [shared.core.reactive :as re]
            [shared.core.util :as util]))

(def root-path [:voice-insights :charts])
(def settings-path (conj root-path :settings))
(def data-by-chart-id-path (conj root-path :data :by-chart-id))

(defn ->formatted-chart-data [data & {:keys [grouping-key]}]
  (let [grouping-key (or grouping-key "time_grouping")
        data-keys (or (some->> data (first) (keys) (into #{})) #{})]
    (cond
      (contains? data-keys grouping-key)
      (->> data
           (group-by #(get % grouping-key))
           (mapv (fn [[time-grouping vals]]
                   [time-grouping
                    (->> vals
                         (sort-by (fn [r]
                                    (let [raw-val (get r "time_value")]
                                      (try
                                        (condp = time-grouping
                                          "all" 1
                                          "hourly" (util/parse-int raw-val)
                                          "day-of-week" (get constants/days-of-the-week-map raw-val 7)
                                          "daily" (t.c/to-long (t.f/parse (t.f/formatter "yyyy-MM-dd") raw-val))
                                          raw-val)
                                        (catch :default _
                                          raw-val)))))
                         (mapv (fn [r]
                                 (let [raw-val (get r "time_value")]
                                   (-> r
                                       (assoc "raw_time_value" raw-val)
                                       (assoc "time_value" (try
                                                             (let [parse-daily #(->> %
                                                                                     (t.f/parse (t.f/formatter "yyyy-MM-dd"))
                                                                                     (t.f/unparse (t.f/formatter "MMM dd, EEE")))
                                                                   parse-day-part util/capitalize-words
                                                                   parse-shift #(try
                                                                                  (let [[daily day-part] (s/split % " ")]
                                                                                    (str (parse-daily daily)
                                                                                         " ("
                                                                                         (parse-day-part day-part)
                                                                                         ")"))
                                                                                  (catch :default _
                                                                                    %))]
                                                               (condp = time-grouping
                                                                 "all" "Total"
                                                                 "hourly" (util/readable-hour-num raw-val)
                                                                 "day-of-week" raw-val
                                                                 "daily" (parse-daily raw-val)
                                                                 "shift" (parse-shift raw-val)
                                                                 "day-part" (parse-day-part raw-val)
                                                                 raw-val))
                                                             (catch :default _
                                                               raw-val))))))))]))
           (into {}))

      :else
      data)))

(re/reg-auth0-loader
  :voice-insights/load-chart-data
  (fn [[[_ chart-id]]]
    (conj data-by-chart-id-path chart-id))
  (fn [db [_ chart-id]]
    (when (and chart-id (concepts.d/current-concept-id db))
      {:method :post
       :url "/api/vi/charts/by-id"
       :json-params (assoc (vi.d/base-query-args db {}) :chart-id chart-id)}))
  :transf (fn [resp]
            (or (some-> resp
                        :body
                        (util/json-string->map-basic)
                        (first)
                        (second)
                        (->formatted-chart-data))
                {}))
  :error-transf (fn [] {}))

(re/reg-auth0-load-sub
  :voice-insights/chart-data-
  (fn [_ chart-id]
    (conj data-by-chart-id-path chart-id))
  :voice-insights/load-chart-data)

(re/reg-sub
  :voice-insights/charts-loading?-
  (fn [db [_ chart-ids]]
    (->> chart-ids
         (mapv (fn [chart-id]
                 (let [v (get-in db (conj data-by-chart-id-path chart-id))]
                   (cond
                     (= v :loading) true
                     (nil? v) (do
                                (re/dispatch-load [:voice-insights/load-chart-data [_ chart-id]])
                                true)
                     :else false))))
         (some true?)
         (boolean))))

(re/reg-event-db
  :voice-insights/chart-clear-data re/middleware
  (fn [db [chart-id]]
    (assoc-in db (conj data-by-chart-id-path chart-id) nil)))

(re/reg-event-fx
  :voice-insights/chart-initialize-listener re/middleware
  (fn [_ [chart-id clear-data?]]
    (when clear-data?
      (re/dispatch [:voice-insights/chart-clear-data chart-id]))
    {:forward-events {:register (keyword "vi-charts-initialization-listener-" chart-id)
                      :events #{:concepts/select :locations/select :core/select-crew-type
                                :core/select-timeframe :locations/clear-selected
                                :core/timeframe-date-range-changed}
                      :dispatch-to [:voice-insights/chart-clear-data chart-id]}}))